<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Across the Bridge</span></p>
<p class="bk-title1"><span>Stories</span></p>
<p class="authorname"><span>Mavis Gallant</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_02.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?24032f77